import React, {useContext} from 'react';
import { Box, Button, Center, Flex, Heading, Icon, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import { FaPen, FaRobot, FaCheck } from "react-icons/fa";
import { useStore } from "../../Store";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { useBreadcrumbs } from '../../contexts/BreadcrumbProvider';
import { ModalBox } from '../ModalBox';

export const CreationMode = ({createProductInDB, type, currentStep}) => {

  const {updateStates} = useStore((state) => state);
  const { publisher } = useContext(PublisherAndUserContext);
  const {
    isOpen,
    onOpen,
    onClose,
  } = useDisclosure();
  const navigate = useNavigate();
  const { addBreadcrumb } = useBreadcrumbs();

  const upgradeToPro = () => {
      addBreadcrumb("Pricing Plan", "/pricingplan", true)
      navigate("/pricingplan")
  }
  return (
    <Box w="100%">
      <Heading as='h3' size='lg' mb={4}>Choose Creation Mode</Heading>
      <Text fontSize="md" mb={8} color="gray.600">Select how you'd like to create your content</Text>

      <Flex direction={{ base: "column", md: "row" }} gap={6} mb={8}>
        {/* Manual Creation Card */}
        <Box bg="white" p={6} rounded="lg" shadow="sm" _hover={{ shadow: "md" }} flex={1}>
          <Center flexDir="column" mb={6}>
            <Center w={16} h={16} bg="blue.50" rounded="full" mb={4}>
              <Icon as={FaPen} boxSize={8} color="blue.500" />
            </Center>
            <Heading size="md">Manual Creation</Heading>
          </Center>

          <Stack spacing={3} mb={6}>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Full creative control over content structure</Text>
            </Flex>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Create custom layouts and formatting</Text>
            </Flex>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Import existing content easily</Text>
            </Flex>
          </Stack>

          <Button w="full" variant="outline" colorScheme="blue" onClick={createProductInDB}>
            Start Manual Creation
          </Button>
        </Box>

        {/* AI Assistance Card */}
        <Box bg="white" p={6} rounded="lg" shadow="sm" _hover={{ shadow: "md" }} flex={1}>
          <Center flexDir="column" mb={6}>
            <Center w={16} h={16} bg="blue.50" rounded="full" mb={4}>
              <Icon as={FaRobot} boxSize={8} color="blue.500" />
            </Center>
            <Heading size="md">AI Assistance</Heading>
          </Center>

          <Stack spacing={3} mb={6}>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Smart content suggestions and generation</Text>
            </Flex>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Automated formatting and structure</Text>
            </Flex>
            <Flex align="start">
              <Icon as={FaCheck} color="green.500" mt={1} mr={3} />
              <Text color="gray.600">Quick content optimization</Text>
            </Flex>
          </Stack>

          <Button 
            w="full" 
            colorScheme="blue" 
            onClick={
              publisher.creditsAvailable + publisher.extraCreditsAvailable > 0 ? 
              () => {
                navigate(`/create${type}/${currentStep + 1}`)
                updateStates({[`${type}CurrentStep`]: currentStep + 1})
              } 
              : onOpen} >
            Start with AI Help
          </Button>
        </Box>
      </Flex>
      <ModalBox
        title="Upgrade"
        isOpen={isOpen}
        onClose={onClose}
        isFooter={true}
        onCancel={onClose}
        confirmButtonType={true}
        onConfirm={upgradeToPro}
        isDeleteButton={false}
        confirmButtonText="Upgrade To Pro"
        description={`You’ve used all your available credits.
        Please upgrade to Pro to continue using this feature.`}
      />
    </Box>
  );
};

